import * as React from 'react';

import { createIcon } from '../Icon';
export const ColumnsIcon = createIcon(
  <path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18" />,
  'ColumnsIcon'
);
